import { createContext, useContext } from "react";

export const CommonContext = createContext();

export const useCommonContext = () =>{
    const data  = useContext(CommonContext);
    return data
}